// extracted by mini-css-extract-plugin
export default {"ticket":"GAqnb","name":"_3uLqq","tax":"_2MTwp","inner":"_14n34","quantity":"_1id5A","price":"_2lGWZ","soldOut":"_3xcY4","description":"_sJvD","divider":"_22x0F","tooltip":"_36CNg"};